import { render } from "./CreateAssignmentForm.vue?vue&type=template&id=17dccfd9&ts=true"
import script from "./CreateAssignmentForm.vue?vue&type=script&lang=ts"
export * from "./CreateAssignmentForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__